"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asContentArray = exports.asWithData = void 0;
function asWithData(content) {
    return {
        data: {
            content: content,
        },
    };
}
exports.asWithData = asWithData;
function asContentArray(translation) {
    if (!translation.data.content) {
        return [];
    }
    return Array.isArray(translation.data.content)
        ? translation.data.content
        : Object.values(translation.data.content);
}
exports.asContentArray = asContentArray;
//# sourceMappingURL=content.helpers.js.map